import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCSCD06UCUkd26aWg9BTvyp80u462g6PAA',
  authDomain: 'gh-home-bf859.firebaseapp.com',
  projectId: 'gh-home-bf859',
  storageBucket: 'gh-home-bf859.firebasestorage.app',
  messagingSenderId: '264013788166',
  appId: '1:264013788166:web:0ac1dd7d5368f4c2543f87',
  measurementId: 'G-TVGJ66BFFN',
};

// 初始化 Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
